import { useMonitorOutput } from './useMonitorOutput';
export function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(monitor, collector || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/dist/esm/hooks/useCollectedProps.js
// module id = 1109
// module chunks = 0